import { jsx as _jsx } from "react/jsx-runtime";
import { CleanLetterhead, CleanFooter, CustomSectionsBody, SectionNumberingProvider, TemplateDocument, } from '../../../atoms/index.js';
export const metadata = {
    templateKey: 'clean_bilaga',
    version: 'v1',
    category: 'Övriga avtal',
    // Descriptive (non-contract) option label in the "Skapa bilaga från mall"
    // list — the real bilaga name is the user's mandatory `document_title`
    // override (titleFromValueKey), which defaults to the clean "Bilaga".
    title: 'Anpassningsbar bilaga',
    shortTitle: 'Anpassningsbar bilaga',
    titleFromValueKey: 'document_title',
    // No form number ("RR-xx") on clean documents — CleanLetterhead/CleanFooter
    // omit it; this empty string is never rendered.
    formNumber: '',
    preamble: '',
    description: 'En tom bilaga som du fyller med eget innehåll. Bifogas valfritt avtal ' +
        'och har ingen egen signering — den följer med det signerade avtalet.',
    status: 'active',
    attachableTo: ['*'],
    partySlots: [],
    customSectionsBody: true,
    defaultCustomSections: [{ title: 'Innehåll' }],
};
export const variableSchema = [
    {
        key: 'document_title',
        label: 'Dokumenttitel',
        type: 'text',
        section: 'Dokument',
        default: 'Bilaga',
        requiredAtFinal: true,
        help: 'Visas överst i dokumentet (om sidhuvud är på) och blir bilagans namn.',
    },
    {
        key: 'show_header',
        label: 'Lägg till sidhuvud',
        type: 'boolean',
        section: 'Dokument',
        default: true,
        help: 'Visar dokumenttiteln under logotyperna. Logotyperna visas alltid.',
    },
];
export const sampleValues = {
    document_title: 'Bilaga – Ordningsregler',
    show_header: true,
};
export function Letterhead({ values, } = {}) {
    const showHeader = values?.['show_header'] !== false;
    const title = (values?.['document_title'] ?? '').trim() || 'Bilaga';
    return _jsx(CleanLetterhead, { title: showHeader ? title : null });
}
export function PageFooter() {
    return _jsx(CleanFooter, {});
}
export function Body({ values, mode, }) {
    return (_jsx(SectionNumberingProvider, { sections: [], values: values, mode: mode, children: _jsx(CustomSectionsBody, {}) }));
}
export function Component(props) {
    return (_jsx(TemplateDocument, { header: _jsx(Letterhead, { values: props.values }), footer: _jsx(PageFooter, {}), children: _jsx(Body, { ...props }) }));
}
//# sourceMappingURL=index.js.map